export enum showElementsEnum {
  ONLY_ANNOTATED = 'ONLY_ANNOTATED',
  ALL = 'ALL',
}

export interface AnnotationsPreferences {
  showElements: showElementsEnum;
}
